import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import { useTranslate } from 'react-admin'
import Typography from '@mui/material/Typography'
import LibraryAddIcon from '@mui/icons-material/LibraryAdd'
import BaseNode from './BaseNode'
import { DataStoreWriteNodeData } from '../types'
import { xxllncColor } from '../../../layout/theme/color'

const DataStoreWriteNode: FC<NodeProps> = ({ id, data, selected }) => {
  const translate = useTranslate()
  const nodeData = data as DataStoreWriteNodeData
  const identifier = (nodeData.identifier ?? '').trim()
  const hasContent = Boolean((nodeData.content ?? '').trim())
  const isPlain = nodeData.storageMode === 'plain'
  const keyValue = (nodeData.key ?? '').trim()
  const summary = translate(
    isPlain ? 'workflow.node.dataStoreWritePlainSummary' : 'workflow.node.dataStoreWriteVectorSummary',
  )
  const subtitle = identifier
    ? `${summary} · ${identifier}${isPlain && keyValue ? ` · ${keyValue}` : ''}`
    : translate('workflow.node.dataStoreMissingIdentifier')

  const showError = !identifier || !hasContent || (isPlain && !keyValue)
  const errorText = !identifier
    ? translate('workflow.node.dataStoreMissingIdentifier')
    : isPlain && !keyValue
      ? translate('workflow.node.dataStoreMissingKey')
      : translate('workflow.node.dataStoreMissingContent')

  return (
    <BaseNode
      // eslint-disable-next-line camelcase
      nodeType="data_store_write"
      icon={<LibraryAddIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    >
      {showError && (
        <Typography
          variant="caption"
          sx={{
            color: xxllncColor.orange100,
            fontWeight: 600,
            display: 'block',
            lineHeight: 1.35,
          }}
        >
          {errorText}
        </Typography>
      )}
    </BaseNode>
  )
}

export default memo(DataStoreWriteNode)
